import initialState from '../../initialState';
import Immutable from 'seamless-immutable';
import { types } from './actions';
import {ClientRecordModel, GlobalClientRecordModel} from './models';
import { ReportTableModel } from '../../../models/ReportTableModel';

export default function clientsReportReducer(state = Immutable(initialState.reports.clients), action) {
  switch (action.type) {
    case types.LOAD_CLIENTS_REPORT: {
      return Immutable.merge(state, {
        loading: true,
        pagedData: ReportTableModel.pageRequested(state.pagedData, action.pageNumber, action.pageSize, action.filterBy, action.sortBy),
      });
    }
    case types.LOAD_FRESH_CLIENTS_REPORT_SUCCESS: {
      const result = action.result;
      return Immutable.merge(state, {
        loading: false,
        pagedData: ReportTableModel.pageReady(state.pagedData, result.totalDataCount, result.data.map(r => new ClientRecordModel(r))),
      });
    }
    case types.LOAD_NEXT_CLIENTS_REPORT: {
      return Immutable.merge(state, {
        pagedData: ReportTableModel.nextPageRequested(state.pagedData, action.pageNumber, action.pageSize),
      });
    }
    case types.LOAD_NEXT_CLIENTS_REPORT_SUCCESS: {
      const result = action.result;
      return Immutable.merge(state, {
        pagedData: ReportTableModel.pageReady(state.pagedData, result.totalDataCount, result.data.map(r => new ClientRecordModel(r))),
      });
    }
    case types.LOAD_GLOBAL_CLIENTS_REPORT: {
      return Immutable.merge(state, {
        loading: true,
        globalClientsPageData: ReportTableModel.pageRequested(state.globalClientsPageData, action.pageNumber, action.pageSize, action.filterBy, action.sortBy),
      });
    }
    case types.CLEAR_GLOBAL_CLIENTS_REPORT: {
      return Immutable.merge(state, {
        loading: false,
        globalClientsPageData: new ReportTableModel({ pageNumber: 1, pageSize: 100 },  [], []),
      });
    }
    case types.LOAD_FRESH_GLOBAL_CLIENTS_REPORT_SUCCESS: {
      const result = action.result;
      return Immutable.merge(state, {
        loading: false,
        globalClientsPageData: ReportTableModel.pageReady(state.globalClientsPageData, result.totalDataCount, result.data.map(r => new ClientRecordModel(r))),
      });
    }
    case types.LOAD_NEXT_GLOBAL_CLIENTS_REPORT: {
      return Immutable.merge(state, {
        globalClientsPageData: ReportTableModel.nextPageRequested(state.globalClientsPageData, action.pageNumber, action.pageSize),
      });
    }
    case types.LOAD_NEXT_GLOBAL_CLIENTS_REPORT_SUCCESS: {
      const result = action.result;
      return Immutable.merge(state, {
        globalClientsPageData: ReportTableModel.pageReady(state.globalClientsPageData, result.totalDataCount, result.data.map(r => new GlobalClientRecordModel(r))),
      });
    }
    default:
      return state;
  }
}
